import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import { pOturumAc, rKullanici } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<pOturumAc, IInputDataStateModel<pOturumAc, rKullanici>, rKullanici>(
  ActionSubTypes.API_OTURUMAC,
  DefaultInputDataStateModel<pOturumAc, rKullanici>()
);
